import { Github, Mail, PhoneCall, Linkedin, Type } from '@geist-ui/react-icons'
import tag from '../assets/imgs/tag.png'
export default function HireMe(p) {
  function formSub(e) {
    e.preventDefault();
    e.target.button.disabled = "true";

    let buttonTxt = e.target.button.innerText,
      sub = e.target.subject.value,
      email = e.target.email.value,
      message = e.target.message.value.replaceAll("\n", "<br>"),
      xhr = new XMLHttpRequest(),
      url = `https://pedantic-wescoff-b9cac2.netlify.app/.netlify/functions/send-email?query=${JSON.stringify(
        {
          subject: sub,
          text: message + "\n" + "Mail Address: " + email,
          email: email,
          email_to: "ahmedelswerkey@gmail.com",
        }
      )}`;
    e.target.button.innerText = "Sending...";
    xhr.open("post", url);
    xhr.send();
    xhr.onreadystatechange = (d) => {
      e.target.button.innerText = buttonTxt;
    e.target.button.disabled = false;


      e.target.subject.value =
        e.target.email.value =
        e.target.message.value =
        "";
    };
  }
  return (
    <div id="hire_me">
      <div id="outer">
        <div
          style={{
            float: "right",
            width: "50%",
            display: "inline-block",
            overflow: " hidden",
          }}
        >
          <img
            loading="lazy"
            src={tag}
            style={{ width: "50vw" }}
            alt="code photo"
          />
        </div>
        <div
          style={{
            float: "left",
            width: "50%",
            display: "flex",
            justifyContent: "center",
            flexFlow: "column",
            height: "100%",
          }}
        >
          <h2
            style={
              {
                /*filter: 'hue-rotate(130deg)'*/
              }
            }
          >
            Feel free contacting me anytime 😄
          </h2>
          <div id="contact-det">
            <div>
              {/* <div className="facebook"></div> */}
              <div className="email">
                <a href="mailto:AhmedElswerkey@gmail.com">
                  <Mail />
                  <div>Ahmed.Elswerkey</div>
                </a>
              </div>

              <div className="whatsup">
                <a href="https://api.whatsapp.com/send?phone=+201092129552">
                  <svg
                    style={{ width: "1.3rem", paddingLeft: " 2px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fab"
                    data-icon="whatsapp"
                    className="svg-inline--fa fa-whatsapp fa-w-14"
                    role="img"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                    />
                  </svg>
                  <div>+201092129552</div>
                </a>
              </div>
              <div className="whatsup">
                <a href="https://swerkyblog.wordpress.com">
                  <Type />
                  <div>swerkyblog</div>
                </a>
              </div>
            </div>
            <div>
              <div className="github">
                <a href="https://github.com/Ahmed-Elswerky">
                  {" "}
                  <Github /> <div>Ahmed-Elswerky</div>
                </a>
              </div>
              <div className="linkedin">
                <a href="https://linkedin.com/in/elswerky">
                  <Linkedin /> <div>Elswerky</div>
                </a>
              </div>
            </div>
          </div>
          <div>
            <form onSubmit={formSub} id="contact-form">
              <br />
              <h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style={{
                    enableBackground: "new 0 0 512 512",
                    width: "35px",
                    height: "35px",
                    fill: "white",
                    verticalAlign: "bottom",
                  }}
                  xmlSpace="preserve"
                >
                  <g>
                    <g>
                      <path d="M485.743,85.333H26.257C11.815,85.333,0,97.148,0,111.589V400.41c0,14.44,11.815,26.257,26.257,26.257h459.487    c14.44,0,26.257-11.815,26.257-26.257V111.589C512,97.148,500.185,85.333,485.743,85.333z M475.89,105.024L271.104,258.626    c-3.682,2.802-9.334,4.555-15.105,4.529c-5.77,0.026-11.421-1.727-15.104-4.529L36.109,105.024H475.89z M366.5,268.761    l111.59,137.847c0.112,0.138,0.249,0.243,0.368,0.368H33.542c0.118-0.131,0.256-0.23,0.368-0.368L145.5,268.761    c3.419-4.227,2.771-10.424-1.464-13.851c-4.227-3.419-10.424-2.771-13.844,1.457l-110.5,136.501V117.332l209.394,157.046    c7.871,5.862,17.447,8.442,26.912,8.468c9.452-0.02,19.036-2.6,26.912-8.468l209.394-157.046v275.534L381.807,256.367    c-3.42-4.227-9.623-4.877-13.844-1.457C363.729,258.329,363.079,264.534,366.5,268.761z" />
                    </g>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
                Send me a quick mail
              </h3>
              <br />
              <input
                type="text"
                placeholder="Subject"
                name="subject"
                required
              />
              <input type="email" placeholder="Email" name="email" required />
              <textarea
                type="text"
                placeholder="Details"
                name="message"
                required
              ></textarea>
              <button name="button">Send</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
